export default {
  'pages.workbenchDashboard.title': 'ソフトウェア工場ワークベンチ',
  'pages.workbenchDashboard.subTitle':
    'プロジェクト、リソース、最近の動向を集約し、ソフトウェア工場全体の稼働状況を素早く把握します。',
  'pages.workbenchDashboard.refresh': '更新',
  'pages.workbenchDashboard.loadingError':
    'ワークベンチデータの読み込みに失敗しました。しばらくしてから再試行してください。',
  'pages.workbenchDashboard.partialStatsWarning':
    '一部のプロジェクトコード統計を読み込めませんでした。現在の集計は取得できたデータに基づいています。',
  'pages.workbenchDashboard.empty': '表示できるデータがありません',
  'pages.workbenchDashboard.lastUpdatedAt': '更新日時',
  'pages.workbenchDashboard.kpi.projects': 'プロジェクト数',
  'pages.workbenchDashboard.kpi.activeProjects': '直近 7 日の稼働プロジェクト',
  'pages.workbenchDashboard.kpi.applications': 'アプリケーション数',
  'pages.workbenchDashboard.kpi.codebases': 'コードリポジトリ数',
  'pages.workbenchDashboard.kpi.activeAgents': '稼働 Agent',
  'pages.workbenchDashboard.kpi.totalCodeLines': '総コード行数',
  'pages.workbenchDashboard.kpi.generatedCodeLines': 'AI 生成コード行数',
  'pages.workbenchDashboard.kpi.newCodeLines': '本日の追加コード行数',
  'pages.workbenchDashboard.sections.groupDistribution':
    'プロジェクトグループ分布',
  'pages.workbenchDashboard.sections.resourceComposition': 'リソース構成',
  'pages.workbenchDashboard.sections.activityTrend':
    '直近 7 日のプラットフォーム動向',
  'pages.workbenchDashboard.sections.projectSnapshot':
    'プロジェクト運用スナップショット',
  'pages.workbenchDashboard.sections.recentLogs': '最近のプラットフォーム動向',
  'pages.workbenchDashboard.sections.riskBoard': '構造リスク',
  'pages.workbenchDashboard.sections.quickActions': 'クイックアクション',
  'pages.workbenchDashboard.charts.group.unGrouped': '未分類',
  'pages.workbenchDashboard.charts.resource.projects': 'プロジェクト',
  'pages.workbenchDashboard.charts.resource.applications': 'アプリケーション',
  'pages.workbenchDashboard.charts.resource.codebases': 'コードリポジトリ',
  'pages.workbenchDashboard.charts.resource.activeAgents': '稼働 Agent',
  'pages.workbenchDashboard.risk.noApplications': 'アプリ未作成のプロジェクト',
  'pages.workbenchDashboard.risk.noActiveAgents':
    '稼働 Agent 未割当のプロジェクト',
  'pages.workbenchDashboard.risk.noRecentActivity':
    '14 日間動きのないプロジェクト',
  'pages.workbenchDashboard.risk.ok':
    '現時点で目立った構造リスクはありません。',
  'pages.workbenchDashboard.table.project': 'プロジェクト',
  'pages.workbenchDashboard.table.group': 'グループ',
  'pages.workbenchDashboard.table.apps': 'アプリ',
  'pages.workbenchDashboard.table.agents': '稼働 Agent',
  'pages.workbenchDashboard.table.codeLines': 'コード行数',
  'pages.workbenchDashboard.table.lastActivity': '最新動向',
  'pages.workbenchDashboard.quick.projects': 'プロジェクト一覧',
  'pages.workbenchDashboard.quick.devAgents': '開発 Agent 管理',
  'pages.workbenchDashboard.quick.estimationStandards': '見積基準',
  'pages.workbenchDashboard.log.empty': '最近の動向はありません',
  'pages.workbenchDashboard.trend.totalOperations': '総操作数',
  'pages.workbenchDashboard.trend.failedOperations': '失敗操作数',
};
